"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EqualValidator = void 0;
const forms_1 = require("@angular/forms");
class EqualValidator {
    constructor(validateEqual) {
        this.validateEqual = validateEqual;
    }
    validate(c) {
        // self value (e.g. retype password)
        const v = c.value;
        // control value (e.g. password)
        const e = c.root.get(this.validateEqual);
        // value not equal
        if (e && v !== e.value) {
            // this.csValidateEqual = false;
            // return;
            return {
                validateEqual: false
            };
        }
        return null;
    }
}
exports.EqualValidator = EqualValidator;
//# sourceMappingURL=equal.validator.js.map